import Leaflet from "../Leaflet";
import colorbrewer from "../../core/tools/colorbrewer";
import environment from "../../environment";

class ServiceAreaAfterSalesLayer {
    constructor(currentMap, options = {}) {
        this.setStyle = this.setStyle.bind(this);
        this.default = this.getDefaultOption();

        const layerConfig = {
            map: currentMap,
            autofocus: false,
            uniqueField: 'Id',
        };

        if (options.remote) {
            layerConfig.showAll = false;
            layerConfig.remote = {
                url: `${environment.get('API_HOST')}/aftersales/stores/serviceareas`,
                method: 'GET',
                params: {
                    serviceType: options.serviceType || 1
                }
            };

            if (options.isTheoretical) {
                layerConfig.success = (response) => {
                    const GetLayer = (name) => require('../index').default.get(name, currentMap);
                    const realLayer = GetLayer('ServiceAreaNetworkAfterSales');
                    const bothActive = realLayer && realLayer.visible();

                    if (bothActive) {
                        response.features = response.features.map(f => ({
                            ...f,
                            properties: {
                                ...f.properties,
                                Order: f.properties.Order + 3,
                                ServiceType: 'Theoretical'
                            }
                        }));
                    }
                    return response;
                };
            }
        } else {
            layerConfig.showAll = true;
        }

        this.layer = new Leaflet.GeoJSONLayer({
            ...layerConfig,
            tag: [
                {
                    property: 'DistanceKM',
                    size: 10,
                    colorize: true,
                    bold: true,
                    box: true,
                    align: 'south',
                    ignore: _ => true
                },
            ],
            symbology: {
                type: 'uniq',
                property: 'Order',
                values: [
                    {
                        value: 1,
                        style: this.default.styles.find(x => x.order === 1),
                    },
                    {
                        value: 2,
                        style: this.default.styles.find(x => x.order === 2),
                    },
                    {
                        value: 3,
                        style: this.default.styles.find(x => x.order === 3)
                    },
                    {
                        value: 4,
                        style: this.default.styles.find(x => x.order === 4),
                    },
                    {
                        value: 5,
                        style: this.default.styles.find(x => x.order === 5),
                    },
                    {
                        value: 6,
                        style: this.default.styles.find(x => x.order === 6)
                    }
                ]
            }
        });

        this.layer.setStyle = (styles, reload) => {
            this.setStyle(styles, reload);
        };

        const originalGetStyle = this.layer._getStyle.bind(this.layer);
        this.layer._getStyle = (feature) => {
            const customStyle = feature.properties._customStyle;
            const storeId = feature.properties.StoreId || feature.properties.IdLoja;
            const registryStyle = !customStyle && storeId && this.layer._customStoreStyles
                ? this.layer._customStoreStyles[storeId]
                : null;
            const activeStyle = customStyle || registryStyle;

            if (activeStyle) {
                const order = feature.properties.Order;
                if (order >= 4) {
                    return { color: '#000000', fillColor: '#000000', fillOpacity: 0, opacity: 1, weight: activeStyle.weight, clickable: false };
                }
                const c = order === 1 ? activeStyle.color[3] : order === 2 ? activeStyle.color[2] : activeStyle.color[1];
                return { color: c, fillColor: c, fillOpacity: activeStyle.opacity, opacity: 1, weight: activeStyle.weight, clickable: false };
            }
            return originalGetStyle(feature);
        };

        return this.layer;
    }
 
    setStyle(styles, reload) {
        const { color, opacity, weight } = styles;
        let { symbology, tag } = this.layer.options;
 
        tag[0].ignore = _ => !styles.showLabelRadius;
 
        const raio1 = symbology.values.find(x => x.value === 1);
        const raio2 = symbology.values.find(x => x.value === 2);
        const raio3 = symbology.values.find(x => x.value === 3);
 
        raio1.style.color        = color[3];
        raio1.style.fillColor    = color[3];
        raio1.style.fillOpacity  = opacity;
        raio1.style.weight       = weight;
 
        raio2.style.color        = color[2];
        raio2.style.fillColor    = color[2];
        raio2.style.fillOpacity  = opacity;
        raio2.style.weight       = weight;
 
        raio3.style.color        = color[1];
        raio3.style.fillColor    = color[1];
        raio3.style.fillOpacity  = opacity;
        raio3.style.weight       = weight;
 
        symbology = _.merge(symbology, { values: symbology.values });
        this.layer.setOptions({ symbology, tag });
 
        if (reload) {
            this.layer.reload();
        }
    }
 
    getDefaultOption() {
        return {
            styles: [
                {
                    fillColor: colorbrewer['Default'][4][3],
                    fillOpacity: 0.1,
                    color: colorbrewer['Default'][4][3],
                    opacity: 1,
                    weight: 2,
                    clickable: false,
                    order: 1,
                },
                {
                    fillColor: colorbrewer['Default'][4][2],
                    fillOpacity: 0.1,
                    color: colorbrewer['Default'][4][2],
                    opacity: 1,
                    weight: 2,
                    clickable: false,
                    order: 2,
                },
                {
                    fillColor: colorbrewer['Default'][4][1],
                    fillOpacity: 0.1,
                    color: colorbrewer['Default'][4][1],
                    opacity: 1,
                    weight: 2,
                    clickable: false,
                    order: 3,
                },
                {
                    fillColor: '#000000',
                    fillOpacity: 0,
                    color: '#000000',
                    opacity: 1,
                    weight: 2,
                    clickable: false,
                    order: 4,
                },
                {
                    fillColor: '#000000',
                    fillOpacity: 0,
                    color: '#000000',
                    opacity: 1,
                    weight: 2,
                    clickable: false,
                    order: 5,
                },
                {
                    fillColor: '#000000',
                    fillOpacity: 0,
                    color: '#000000',
                    opacity: 1,
                    weight: 2,
                    clickable: false,
                    order: 6,
                }
            ]
        };
    }
}

export default ServiceAreaAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/ServiceAreaAfterSalesLayer.js